exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-artist[data-v-effb9b1c] {\n  margin: auto;\n  text-align: center;\n  color: #505050;\n  padding-top: 3vmin;\n  padding-bottom: 3vmin;\n}\n", ""]);

// exports
